<div class="change-tag-container">
 
  
    <div class="change-tag-header">
        <h4 class="change-tag-title">
            <i class="fa-solid fa-tags me-2"></i>
            Product Tag Management
        </h4>
    </div>


    <div class="change-tag-content">
        <!-- Verified Tag Section -->
        <div class="tag-section">
            <label class="tag-label">
                <i class="fa-solid fa-shield-check me-2"></i>
                Verified Tag
            </label>
            <select class="tag-select" (change)="setVerifiedTag($event)">
                <option [selected]="v?.toLowerCase()?.trim() == product?.verifiedTag?.toLowerCase()?.trim()"
                    *ngFor="let v of verifiedTagOptions" [value]="v">
                    {{ v || 'None' }}
                </option>
            </select>
        </div>

        <!-- Additional Tag Section -->
        <div class="tag-section">
            <label class="tag-label">
                <i class="fa-solid fa-star me-2"></i>
                Additional Tag
            </label>
            <!-- <select class="tag-select" (change)="setAdditionalTag($event)">
                <option [selected]="v.toLowerCase() == product?.additionalTag?.toLowerCase()"
                    *ngFor="let v of additionalTagOptions" [value]="v">
                    {{ v || 'None' }}
                </option>
            </select> -->
            <div class="tag-select">
                <ng-container *ngFor="let v of additionalTagOptions">
                    <div class="d-flex align-items-center" *ngIf="v">
                        <input type="checkbox" [id]="'checkbox'+v"
                            (change)="$event.target?.checked ? additionalTags.add(v) : additionalTags.delete(v); updateAdditionalTags()"
                            class="mr-2" [checked]="additionalTags.has(v.trim())">
                        <label style="margin:0">{{ v || 'None' }}</label>
                    </div>
                </ng-container>


            </div>
        </div>

        <!-- Dynamic Content Based on Additional Tag -->
        <div class="dynamic-content mb-2" *ngIf="additionalTags">
            <!-- Must Try - Product Variant Selection -->
            <div class="tag-section" *ngIf="additionalTags.has('must try')">
                <label class="tag-label">
                    <i class="fa-solid fa-link me-2"></i>
                    Link Product Variant ({{ product?.memberShopProductsVariations?.length || 0 }})
                </label>
                <select class="tag-select" (change)="setHoverLink($event)">
                    <option value="">None</option>
                    <option *ngFor="let variant of product?.memberShopProductsVariations ?? []"
                        [selected]="product?.linked == variant.value" [value]="variant.value">
                        {{ variant.value }}
                    </option>
                </select>
            </div>

            <!-- Human Icon - Employee Selection -->
            <div class="tag-section" *ngIf="additionalTags.has('human icon')">
                <label class="tag-label">
                    <i class="fa-solid fa-user me-2"></i>
                    Link Employee ({{ product?.bizCompanyEmployees?.length || 0 }})
                </label>
                <select class="tag-select" (change)="setHoverLink($event)">
                    <option value="">None</option>
                    <option *ngFor="let emp of product?.bizCompanyEmployees ?? []"
                        [selected]="product?.linked == emp.name" [value]="emp.name">
                        {{ emp.name }}
                    </option>
                </select>
            </div>

            <!-- Star - Custom Text -->
            <div class="tag-section" *ngIf="additionalTags.has('Hidden Gem') || additionalTags.has('star')">
                <label class="tag-label">
                    <i class="fa-solid fa-pen me-2"></i>
                    Custom Tooltip
                </label>
                <input type="text" [value]="product?.linked" placeholder="Enter custom text..." class="tag-input"
                    (keyup)="setHoverLink($event)" />
            </div>

            <!-- Youtube - Links -->
            <div class="tag-section" *ngIf="additionalTags.has('youtube')">
                <label class="tag-label">
                    <i class="fa-brands fa-youtube me-2"></i>
                    YouTube Links
                </label>
                <textarea class="tag-textarea" [value]="product?.linked"
                    placeholder="Enter YouTube links separated by new lines..." (keyup)="setHoverLink($event)"
                    (change)="setHoverLink($event)" rows="4">
        </textarea>
                <button class="btn btn-outline-primary btn-sm mt-2" (click)="openYoutubeIframes()">
                    <i class="fa-solid fa-play me-1"></i>
                    Test YouTube Links
                </button>
            </div>
        </div>

        <!-- Map Tag Section -->
        <div class="tag-section">
            <label class="tag-label">
                <i class="fa-solid fa-building me-2"></i>
                Map Biz Tags
            </label>

            <!-- Loading state -->
            <div class="text-center py-3" *ngIf="loadingTags">
                <i class="fa-solid fa-spinner fa-spin me-2"></i>
                Loading tags...
            </div>

            <!-- Tag groups -->
            <div class="tag-groups-container" *ngIf="!loadingTags && tagGroups.length > 0">
                <div class="tag-group" *ngFor="let group of tagGroups">
                    <h6 class="tag-group-title">
                        <i class="fa-solid fa-tags me-2"></i>
                        {{ group.name || group.groupName || 'Tags' }}
                    </h6>
                    <div class="tag-group-items">
                        <button type="button" class="tag-item" [class.selected]="isMapTagSelected(tag)"
                            *ngFor="let tag of group.tags || group.items || []" (click)="toggleMapTag(tag)">
                            {{ tag }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- No tags available -->
            <div class="text-center py-3 text-muted" *ngIf="!loadingTags && tagGroups.length === 0">
                <i class="fa-solid fa-info-circle me-2"></i>
                No tags available
            </div>
        </div>
        <!-- Map User Tag Section -->
        <div class="tag-section">
            <label class="tag-label">
                <i class="fa-solid fa-user me-2"></i>
                Map User Tag
            </label>

            <!-- Loading state -->
            <div class="text-center py-3" *ngIf="loadingTags">
                <i class="fa-solid fa-spinner fa-spin me-2"></i>
                Loading tags...
            </div>

            <!-- Tag groups -->
            <div class="tag-groups-container" *ngIf="!loadingTags && tagGroupsUser.length > 0">
                <div class="tag-group" *ngFor="let group of tagGroupsUser">
                    <h6 class="tag-group-title">
                        <i class="fa-solid fa-tags me-2"></i>
                        {{ group.name || group.groupName || 'Tags' }}
                    </h6>
                    <div class="tag-group-items">
                        <button type="button" class="tag-item" [class.selected]="isMapUserTagSelected(tag)"
                            *ngFor="let tag of group.tags || group.items || []" (click)="toggleMapUserTag(tag)">
                            {{ tag }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- No tags available -->
            <div class="text-center py-3 text-muted" *ngIf="!loadingTags && tagGroupsUser.length === 0">
                <i class="fa-solid fa-info-circle me-2"></i>
                No tags available
            </div>
        </div>
    </div>

    <div class="p-3">
      <label class="m-0 mr-2">Custom Book Button:</label>
      <input type="text" placeholder="Custom Book Button"  [value]="product.customBookButton" (change)="setCustomBookButton($event)" class="form-control"/> 
    </div>

    <div class="p-3">
      <label class="m-0 mr-2">Booking Bonus:</label>
      <input type="number" placeholder="Booking bonus"  [value]="product.bookingPercentOff" (change)="setBonus($event)" class="form-control"/> 
    </div>

    <div class="p-3">
          <app-product-types-list [productId]="product?.id" [categoryId]="product?.categoryId"></app-product-types-list>
    </div>

    <div class="change-tag-footer">
        <button class="btn btn-secondary btn-sm" (click)="closeModal()">
            <i class="fa-solid fa-times me-1"></i>
            Close
        </button>
    </div>
</div>